const API_BASE = import.meta.env.VITE_API_URL || "https://pause-api-production.up.railway.app";
const API = API_BASE + "/api/v1";

const SUPABASE_URL = "https://bakfxfsuxxbirgvfzhkn.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJha2Z4ZnN1eHhiaXJndmZ6aGtuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk0MDcwMjIsImV4cCI6MjA1NDk4MzAyMn0.D2q-1gOsjPOi5RqMEN5FxEXJt2r_jPBkxDyPk4MYz38";

// ── 토큰 만료 체크 (만료 5분 전이면 true) ──
function isTokenExpiringSoon(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return Date.now() > (payload.exp - 300) * 1000; // 5분 전부터 갱신
  } catch { return true; }
}

// ── Supabase refresh_token으로 새 access_token 발급 ──
let refreshPromise = null;
async function refreshAccessToken() {
  if (refreshPromise) return refreshPromise;

  const refreshToken = localStorage.getItem("phase_refresh_token");
  if (!refreshToken) return null;

  refreshPromise = (async () => {
    try {
      const res = await fetch(`${SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "apikey": SUPABASE_ANON },
        body: JSON.stringify({ refresh_token: refreshToken }),
      });
      if (!res.ok) return null;
      const data = await res.json();
      if (data.access_token) {
        localStorage.setItem("phase_token", data.access_token);
        if (data.refresh_token) localStorage.setItem("phase_refresh_token", data.refresh_token);
        return data.access_token;
      }
      return null;
    } catch { return null; }
    finally { refreshPromise = null; }
  })();

  return refreshPromise;
}

// ── 유효한 토큰 반환 (만료 임박 시 자동 갱신) ──
async function getValidToken(token) {
  if (!token) return null;
  if (!isTokenExpiringSoon(token)) return token;
  const newToken = await refreshAccessToken();
  return newToken || token;
}

export async function api(path, opts = {}, token = null) {
  const validToken = token ? await getValidToken(token) : null;

  // 갱신된 토큰이면 App.jsx에 알림
  if (validToken && validToken !== token) {
    localStorage.setItem("phase_token", validToken);
    window.dispatchEvent(new Event("phase-token-refreshed"));
  }

  const h = { "Content-Type": "application/json", ...opts.headers };
  if (validToken) h["Authorization"] = `Bearer ${validToken}`;
  const r = await fetch(`${API}${path}`, { ...opts, headers: h });

  if (r.status === 401) {
    // 갱신 한 번 더 시도
    const retryToken = await refreshAccessToken();
    if (retryToken) {
      localStorage.setItem("phase_token", retryToken);
      window.dispatchEvent(new Event("phase-token-refreshed"));
      const h2 = { "Content-Type": "application/json", ...opts.headers };
      h2["Authorization"] = `Bearer ${retryToken}`;
      const r2 = await fetch(`${API}${path}`, { ...opts, headers: h2 });
      if (r2.ok) return r2.json();
    }
    // 갱신도 실패 → 로그아웃
    localStorage.removeItem("phase_token");
    localStorage.removeItem("phase_refresh_token");
    localStorage.removeItem("phase_user");
    window.location.reload();
    throw new Error("세션이 만료되었습니다. 다시 로그인해주세요.");
  }
  if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.error || "요청 실패"); }
  return r.json();
}

export function trackEvent(eventName, extra = {}) {
  const token = localStorage.getItem("phase_token");
  if (!token) return;
  fetch(`${API}/telemetry`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      event_name: eventName,
      symbol: extra.symbol || null,
      report_snapshot_id: extra.report_snapshot_id || null,
      meta: { client_event_id: crypto.randomUUID(), ...extra.meta },
    }),
  }).catch(() => {});
}
